var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '02',
  belong: 'THE BLOSSOM HIBIYA',
  title: '支配人',
  profile: 'THE BLOSSOM HIBIYA',
  name: '野内 諒',
  date: '２０１４年入社',
  sm: {
    belong: 'THE BLOSSOM HIBIYA',
    name: '支配人',
  },
  intro: '１年目から高みを目指してチャレンジの連続。副支配人となった今も日々成長を感じている',
  content: [
    {
      title: '失敗は、必ず成長につながることを痛感',
      text: '子どもの頃から祖父母の旅館経営を見て育ち、接客業に関心がありました。大学では国際関係を学び、志望先に空港、ウエディングと視野を広げながらもホテル業界へ。実際に入社するとイメージよりも厳しい世界でした。マニュアルはあってないようなもの、対応はお客さまごとに異なり瞬時に考えて行動しなくてはなりません。それがピタリとはまってお客さまに喜んでいただけた時は、大きなやりがいを感じました。しかし１年目、記憶に残る失敗をしました。気さくな男性のお客さまについ軽々しい態度をとってしまい、「真剣な話をしているのに笑うな」と他のお客さまや同僚の前で怒鳴られたのです。その時は複雑な感情が入り混じりました。しかし今思えば、私にとっていい経験でした。意識が高まり、成長につながりました。',
    },
    {
      title: '3年目でマネージャーに昇格できた理由',
      text: 'インチャージ（時間帯ごとの責任者）の仕事を同期の誰より先に覚えたくて、早く出社して先輩に教えてもらうなど積極的な新人でした。よく切磋琢磨したと思います。そして、3年目でマネージャーに昇格。私も努力しましたが、若手にチャレンジをさせてくれる会社なのです。昇格後はスタッフのモチベーションを上げ、ホテルの目標へメンバーの意識を合わせていくことにも注力しました。 THE BLOSSOM HIBIYAの開業準備では、まず販売プランの策定、料金設定など基盤作りを行いました。「レベニューマネジメント」といい、近隣のイベントなどから宿泊需要を予測して料金を設定するのはホテルが収益を得る重要な仕事です。グループ会社へ出向した際は飛び込み営業も経験しました。企業のお客さまへの営業はホテルの接客と全く異なります。私たちのホテルに興味を持っていただくにはどうするかよく考え、大変勉強になりました。現在はTHE BLOSSOM HIBIYAで副支配人を務めています。ＪＲ九州ホテルグループの中でも日比谷は売上を先導するフラッグシップホテルで、高稼働率の維持は必至です。そのためにも総支配人や会社の意思をメンバーに伝え、全員のベクトルが目指す方向へ揃うよう働きかけています。',
    },
    {
      title: '「慢心するな、限界を決めるな」',
      text: '私の信条は「慢心するな、限界を決めるな」です。昨年は支配人の関門となるM級試験を受け、無事合格しました。今まで33歳で支配人になった方がおられ、私は31歳。その記録を塗り替えるのが目下の目標です（笑）。弊社は、副支配人となって１年足らずの私でも次を目指して試験を受けられる、さまざまなチャレンジができる会社です。入社して10年経つ今も、自身の成長を日に日に感じています。',
    } ],
  career: [
    {
      year: '2014',
      text: 'ＪＲ九州ホテルブラッサム新宿に配属。',
    },
    {
      year: '2017',
      text: 'マネージャーに昇格',
    },
    {
      year: '2019',
      text: 'THE BLOSSOM HIBIYA　開業準備から配属',
    },
    {
      year: '2020.8',
      text: 'グループ会社へ出向',
    },
    {
      year: '2020.12',
      text: 'THE BLOSSOM HIBIYAに復帰',
    },
    {
      year: '2021',
      text: 'チーフマネージャーに昇格',
    },
    {
      year: '2022',
      text: '副支配人に昇格',
    },
    {
      year: '2023',
      text: '支配人に昇格',
      isLast: true,
    } ],
  message: '就職＝自分の人生、と重く捉える必要はありません。<br>仕事でパフォーマンスを発揮できるのは、就職してずっと先の話。<br>学生の今はやりたいことを我慢せず、全てやってほしいと思います。<br>語学力はある方が良いですが、今はなくとも外国人のお客さまと日々接する中で磨かれるし、入社後も勉強できます。<br>まずは元気な人、笑顔で挨拶ができる人に加わってほしいと思います。',
  caption: true,
  navi: {
    prev: {
      title: 'ホテル業界に魅せられ理想を追求。「感謝」と「笑顔」を忘れずにわたしたちにできる最高のサービスを。',
      path: '01',
    },
    next: {
      title: '３度の開業で得たゆるぎない経験。地域の魅力を見つけ、旅行者目線でサービス向上を目指す。',
      path: '03',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }